module.exports = __webpack_public_path__ + "resources/images/piggyBank-cec915902190ad4ae0aab159947072a0-cache.png";